import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

let AddSingleEmployeeForm = (props) => {
    const { t } = useTranslation();

    const { handleSubmit, pristine, submitting, isFrozen } = props;

    return (
        <form className="l-form" onSubmit={handleSubmit}>
            <h3 style={{textAlign: i18next.dir() === 'rtl' ? 'right' : 'left' }}>{t('invoices.addSingleEmployeeFormTitle')}</h3>
            <div className="dependents-info-wrapper-mobile">
                <div>{/* <InfoOutlinedIcon /> */}</div>
                <div>
                    <p>{t('invoices.dependantMeaning')}</p>
                </div>
            </div>
            <div className="add-single-form-wrapper">
                <div className="input-field-container">
                    <label>{t('invoices.singleEmployeeFormFirstNameFieldLabel')}</label>
                    <Field
                        component="input"
                        className="form-input"
                        type="text"
                        name="first_name"
                        placeholder={t('invoices.singleEmployeeFormFirstNameFieldPlaceholder')}
                        disabled={isFrozen}
                    />
                </div>
                <div className="input-field-container">
                    <label>{t('invoices.singleEmployeeFormLastNameFieldLabel')}</label>
                    <Field
                        component="input"
                        className="form-input"
                        type="text"
                        name="last_name"
                        placeholder={t('invoices.singleEmployeeFormLastNameFieldPlaceholder')}
                        disabled={isFrozen}
                    />
                </div>
                <div className="input-field-container">
                    <label>{t('invoices.singleEmployeeFormEmailFieldLabel')}</label>
                    <Field
                        component="input"
                        className="form-input"
                        type="email"
                        name="email_address"
                        placeholder={t('invoices.singleEmployeeFormEmailFieldPlaceholder')}
                        disabled={isFrozen}
                    />
                </div>
                <div className="input-field-container">
                    <label>{t("invoices.singleEmployeeFormPhoneNumberFieldLabel")}</label>
                    <Field
                        component="input"
                        className="form-input"
                        type="number"
                        name="phone_number"
                        placeholder={t("invoices.singleEmployeeFormPhoneNumberFieldPlaceholder")}
                        disabled={isFrozen}
                    />
                </div>

                <Field
                    className="hidden"
                    name="access_token"
                    component="input"
                    style={{ display: 'none' }}
                />

                <Field
                    className="hidden"
                    name="client_id"
                    component="input"
                    style={{ display: 'none' }}
                />
                <div className="input-field-container">
                    <label>{t("invoices.singleEmployeeFormPlanSelectionFieldLabel")}</label>
                    <Field component="select" className="form-input" name="product_id" disabled={isFrozen}>
                        <option>{t("invoices.singleEmployeeFormPlanSelectionFieldDefaultOption")}</option>
                        {props.invoicePlans.map((plan) => (
                            <option key={plan.id} value={plan.id}>
                                {plan.name}
                            </option>
                        ))}
                    </Field>
                </div>
                <div className="input-field-container">
                    <label>{t("invoices.singleEmployeeFormNumberOfBeneficiariesFieldLabel")}</label>
                    <Field
                        component="input"
                        className="form-input"
                        type="number"
                        name="no_of_dependant"
                        placeholder={t("invoices.singleEmployeeFormNumberOfBeneficiariesFieldPlaceholder")}
                        disabled={isFrozen}
                    />
                </div>
                <button className="form-button upload" disabled={pristine || submitting || isFrozen}>
                    {t("invoices.singleEmployeeFormSubmitButtonText")}
                </button>
            </div>
            <div className="dependents-info-wrapper">
                <div>{/* <InfoOutlinedIcon /> */}</div>
                <div>
                    <p>
                        {t("invoices.singleEmployeeFormInfo")}
                    </p>
                </div>
            </div>
        </form>
    );
};

AddSingleEmployeeForm = reduxForm({
    form:"addSingleEmployeeForm"
})(AddSingleEmployeeForm);

AddSingleEmployeeForm = connect(({session})=>({
    initialValues:{access_token:session.user.credentials.accessToken, client_id: session.user.companyInfo.id},
    enableReinitialize:true
}))(AddSingleEmployeeForm);

export default AddSingleEmployeeForm;
